import { Typography } from '@mui/material';
import Modal from 'components/Common/Modal';
import Button from 'components/Common/CustomButton';
import { InfoModalProps } from 'types/modal';

const InfoModal = ({
    onClose,
    isOpen,
    title,
    description,
    loading,
    onConfirm,
    children,
    renderActions,
    hideActionButtons,
}: InfoModalProps) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} modalTitle={title}>
            <>
                <Typography sx={{ fontSize: 18, my: 2, color: '#1F2937', fontWeight: 400 }}>
                    {description && description}
                    {description && children ? <br /> : null}
                    {children && children}
                </Typography>
                {!renderActions && !hideActionButtons && (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                        <Button
                            backgroundColor="white"
                            sx={{
                                border: '1px solid #2B2C54',
                                color: 'black',
                            }}
                            onClick={onClose}
                            width="45%"
                            title="Cancel"
                            style={{ backgroundColor: 'white', marginRight: '10px' }}
                        />
                        <Button variant="contained" loading={loading} onClick={onConfirm} width="45%" title="Confirm" />
                    </div>
                )}
                {renderActions && renderActions()}
            </>
        </Modal>
    );
};
export default InfoModal;
